import { REDIRECT } from 'client/actions/constants';

export function redirect({ path, status }) {
  return {
    type: REDIRECT,
    path,
    status,
  };
}
